import { CustomBuilderComponents } from '@/helpers/enums';

export const whoWeAreBuilderConfigs = {
  name: CustomBuilderComponents.WHO_WE_ARE,
  image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/image.svg',
  inputs: [
    {
      name: 'heading',
      type: 'string',
      required: true,
    },
    {
      name: 'image',
      type: 'object',
      subFields: [
        {
          name: 'src',
          friendlyName: 'Image source',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png'],
          required: true,
        },
        {
          name: 'altText',
          friendlyName: 'Image description text',
          type: 'string',
        },
      ],
    },
    {
      name: 'textHeading',
      type: 'string',
    },
    {
      name: 'textSubHeading',
      type: 'string',
    },
    {
      name: 'textField',
      type: 'customRichTextPistachios',
    },
  ],
};
